import React from "react"

import RentalReaderFormComponent from "../../../V2/Forms/RentalReaderForm"

//TODO - scrap this component
const RentalReaderForm = () => {
  return <RentalReaderFormComponent />
}

export default RentalReaderForm
